import { Routes, Route, Navigate } from 'react-router';
import RootRedirect from './routes/RootRedirect';
import { LoginPage } from './pages/LoginPage';
import ProtectedRoute from './routes/ProtectedRoute';
import { DashboardLayout } from './providers/SidebarProvider';
import { AdminMapView } from './features/admin/map/components/AdminMapView';
import { CrewTable } from './features/admin/crew-management/components/CrewTable';
import { NotFoundPage } from './pages/NotFoundPage';
import { PublicRoute } from './routes/PublicRoute';
import { AdminSettingsPage } from './pages/AdminSettingsPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { ProjectTable } from './features/project/components/ProjectTable';
import { CrewMapView } from './features/crew/map/CrewMapView';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />

      {/* == Public-Routes == */}
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* == Protected Routes == */}
      {/* Admin Routes */}
      <Route element={<ProtectedRoute allowedRoles={['ADMIN']} />}>
        <Route element={<DashboardLayout />}>
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route
            path="/admin/ticket-map/:ticketId?"
            element={<AdminMapView />}
          />
          <Route path="/admin/crew-management" element={<CrewTable />} />
          <Route path="/admin/project-management" element={<ProjectTable />} />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
          <Route
            path="/admin/*"
            element={<Navigate to="/admin/dashboard" replace />}
          />
        </Route>
      </Route>

      {/* Crew Routes */}
      <Route element={<ProtectedRoute allowedRoles={['CREW']} />}>
        <Route element={<DashboardLayout />}>
          <Route path="/crew/ticket-map" element={<CrewMapView />} />
          <Route
            path="/crew/*"
            element={<Navigate to="/crew/ticket-map" replace />}
          />
        </Route>
      </Route>

      {/* Error Route */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
